<template>
  <div
    class="card-action col caps flex items-center hover-toggle fs-s pointer"
    :class="{ 'highlight': highlight }"
    :style="{ 'width': width + '%' }">

    <div v-if="type === 'video' && content.length > 1" class="col-12 center">
      <div class="p2 hover-hide mx-auto text">Play Video</div>
      <div class="hover-show col-12 flex justify-between center">
        <div class="flex-auto p2 border-right hover-red border-black"
          v-for="video in content"
          @click="updateCurrentVideo(video)"
          :key="video.id">
          {{ video.language }}
        </div>
      </div>
    </div>

    <div v-else-if="type === 'video'" class="block col-12 center p2 mx-auto hover-red pointer">
      <div @click="updateCurrentVideo(content[0])" class="text">Play Video</div>
    </div>

    <div v-else-if="type === 'link'" class="mx-auto col-12 center">
      <div v-if="Array.isArray(content) && content.length === 1">
        <a class="hover-red block py1 mx1" v-if="content[0].type === 'url'" :href="content[0].url" target="_blank">{{ content[0].call_to_action }}</a>
        <a class="hover-red block py1 mx1" v-else :href="content[0].file.url" target="_blank">{{ content[0].call_to_action }}</a>
      </div>
      <div v-else-if="Array.isArray(content) && content.length > 1" class="flex-1 py2 border-right">
        <div class="hover-toggle relative">
          <div class="hover-hide text">Featured Links</div>
          <div class="hover-show card-links-dropdown center absolute col-12">
            <div v-for="(item, index) in content" class="my1" :key="index">
              <a class="hover-red block col-12" v-if="item.type === 'url'" :href="item.url" target="_blank">{{ item.call_to_action }}</a>
              <a class="hover-red block col-12" v-else :href="item.file.url" target="_blank">{{ item.call_to_action }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="type === 'exhibitionWebsite'" class="mx-auto col-12 center">
      <a :href="content" class="col-12 block p2 hover-red" target="_blank">Visit Exhibition Website</a>
    </div>

    <div v-else-if="type === 'print'" class="hover-red col-12 center mx-auto py2">
      Print
    </div>

    <div v-else-if="type === 'blank'" class="hover-red col-12 center mx-auto py2">
      {{ content }}
    </div>

    <div v-else class="mx-auto col-12 center py2">&nbsp;</div>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {

  name: 'CardAction',

  data () {
    return {

    }
  },

  methods: {
    ...mapActions([
      'updateCurrentVideo'
    ]),
    print () {
      window.print()
    }
  },

  props: ['width', 'type', 'content'],

  computed: {
    highlight() {
      // return true
      if (Array.isArray(this.$props.content)) {
        return this.$props.content[0].type === 'url' && this.$props.content[0].highlight
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="css" scoped>
  .card-action {
    border-right: 1px solid var(--black);

    &:last-child {
      border-right: none;
    }

    .border-right:last-child {
      border-right: none;
    }

    .card-links-dropdown {
      left: -1px;
      top: calc(-1 * var(--space-2) - var(--space-1) - 1px);
      padding-top: var(--space-1);
      background: var(--col-light);
      border: 1px solid black;

      a:hover {
        color: var(--red);
      }
    }
  }

  .highlight {
    transition: all 0.2s ease-out;

    a {
      background: var(--red);
      color: var(--col-light);
    }

    &:hover {
      background: var(--red);
    }
  }
</style>
